
import Vue from "vue";
import Component from "vue-class-component";
import GoogleMaps from "@/components/GoogleMaps.vue";
import {
  makeMailLink,
  makeWhatsappLink,
  normalizeHttp,
} from "@/components/utils";
import UserService from "@/services/UserService";
import { namespace } from "vuex-class";
import { formatPhone } from "@/components/wmc/format.utils";
import PhoneInput from "@/components/wmc/PhoneInput.vue";

const Notifications = namespace("Notifications");

const emailContatoInitialState = {
  nome: "",
  email: "",
  fone: "",
  mensagem: "",
};

@Component({
  props: {
    pageData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    GoogleMaps,
    PhoneInput,
  },
})
export default class ContatoCustomView extends Vue {
  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;
  private isLoading = false;
  private isFormValid = false;
  private regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    email: (v: string) => {
      return /.+@.+\..+/.test(v) || "Insira um e-mail válido";
    },
  };
  get atendimentoData() {
    const contatos: any[] = [];

    if (
      this.$props.pageData.extras.fone ||
      this.$props.pageData.extras.celular
    ) {
      const telefone = {
        title: "Telefone",
        text: [] as any[],
      };

      if (this.$props.pageData.extras.fone) {
        telefone.text.push({
          icon: "mdi-phone",
          text: formatPhone(this.$props.pageData.extras.fone),
        } as any);
      }

      if (this.$props.pageData.extras.celular) {
        telefone.text.push({
          icon: "mdi-whatsapp",
          text: formatPhone(this.$props.pageData.extras.celular),
          link: makeWhatsappLink(this.$props.pageData.extras.celular),
        } as any);
      }

      contatos.push(telefone);
    }

    if (this.$props.pageData.extras.email) {
      const email = {
        title: "E-mail",
        text: [
          {
            icon: "mdi-email-fast-outline",
            text: this.$props.pageData.extras.email,
            link: makeMailLink(this.$props.pageData.extras.email),
          },
        ],
      };

      contatos.push(email);
    }

    if (this.$props.pageData.extras.site) {
      const site = {
        title: "Site",
        text: [
          {
            icon: "mdi-web",
            text: this.$props.pageData.extras.site,
            link: normalizeHttp(this.$props.pageData.extras.site),
          },
        ],
      };

      contatos.push(site);
    }

    if (this.$props.pageData.extras.horario) {
      const horario_atendimento = {
        title: "Horários de atendimento",
        text: [
          {
            icon: "",
            text: this.$props.pageData.extras.horario,
          },
        ],
      };

      contatos.push(horario_atendimento);
    }

    return contatos;
  }

  private emailContato = { ...emailContatoInitialState };

  onEnviarEmailClick() {
    this.isFormValid = (
      this.$refs.formContato as Vue & { validate: () => boolean }
    ).validate();

    if (this.isFormValid) {
      this.isLoading = true;
      UserService.enviarEmailContato(this.emailContato)
        .then(
          (res) => {
            this.showInfoMessage("Solicitação de contato enviada com sucesso");
            this.emailContato = { ...emailContatoInitialState };
          },
          (error) => {
            this.showInfoMessage(
              "Erro ao enviar solicitação de contato, tente novamente mais tarde"
            );
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
